<template lang="pug">
  .card
    .card__device
      .card__device-image
        img(:src='require(`~/assets/img/store/${device.image_name}.png`)')
      div
        .card__device-name {{ device.type }}
        .card__device-text RED MAGIC 7 Pro
        .card__device-price
          .card__device-coins-icon
            img.currency__coins(height="24" width="24" :src="require('~/assets/img/icons/coins.svg')" alt="coins")
          .card__device-amount {{ device.priceInCoins }}
          .card__device-currency {{ $t('coins') }}
        Button.card__device-button(is-primary, is-small, @click='buy') {{ $t("buy") }}
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  methods: {
    buy () {
      this.$emit('buy')
    }
  }

}
</script>

<style lang="scss" scoped>
.card {
  &__device {
    min-height: 164px;
    min-width: 321px;

    @media (min-width: $breakpointTablet) {
      grid-column: 1 / 3;
    }

    @media (min-width: $breakpointDesktop) {
      grid-column: auto;
    }

    &::before {
      position: absolute;
      right: 0;
      content: "";
      height: 352px;
      width: 80px;
      background: $pink40;
      rotate: -40deg;
      top: -89px;

      @media (min-width: $breakpointTablet) {
        top: 50%;
        margin-top: -164px;
        transform: rotate(30deg);
      }
    }

    &-name {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: #90a4ae;
    }

    &-text {
      margin-top: 8px;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0.02em;
      line-height: 28px;
      color: $white;
    }

    &-image {
      z-index: 1;
      position: relative;
      margin-bottom: 24px;
      flex-shrink: 0;

      @media (min-width: $breakpointTablet) {
        margin-bottom: 0;
        position: absolute;
        top: 20px;
        right: 16px;
        bottom: 20px;
        width: 38.1578%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      img {
        max-width: 100%;
        width: 165px;
        margin: auto;
        display: block;
      }
    }

    &-price {
      display: grid;
      grid-template-columns: 24px 1fr;
      grid-column-gap: 8px;
      align-items: center;
      margin-top: 16px;
      margin-bottom: 28px;
    }

    &-amount {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: $white;
    }

    &-currency {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: $blue-grey10;
      grid-column-start: 2;
    }

    &-button {
      width: 100% !important;
      max-width: 100%;

      @media (min-width: $breakpointTablet) {
        width: auto !important;
        padding-left: 57px !important;
        padding-right: 57px !important;
      }
    }
  }
}

</style>
